// extracted by mini-css-extract-plugin
module.exports = {"select-for-taxation":"select-for-taxation-6d24850182eb01c71acfd9fecd67d6bf"};